module.exports = __webpack_public_path__ + "fonts/Vazir-Bold.ef0b7579.woff";